import { Contract } from 'pricing/types';
import { getMediaContractFileDataUrl } from 'pricing/utilities/media/media';

export const contractFormSetFieldsValue = (contract: Contract) => {
  return {
    breederId: contract.breederId,
    breederName: contract.breederName,
    breederContractConditionId: contract.breederContractConditionId,
    startDate: contract.startDate,
    endDate: contract.endDate,
    contractFile: getMediaContractFileDataUrl(contract.media),
  };
};
